function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  line-height: 1.5;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  display: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  height: 17px;\n  width: 17px;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  display: ",
        ";\n\n  + span {\n    min-height: 17px;\n    line-height: 17px;\n    cursor: ",
        ";\n    color: ",
        ";\n    font-size: 13px;\n    padding-left: 30px;\n    position: relative;\n\n    > span {\n      height: 17px;\n      width: 17px;\n      position: absolute;\n      left: 0;\n      top: 0;\n      opacity: ",
        ";\n      background: url(/icons/unchecked-icon.svg) no-repeat;\n    }\n  }\n\n  &:checked + span > span {\n    opacity: ",
        ";\n    background: url(/icons/checked-icon.svg) no-repeat;\n  }\n\n  // apply focus styles to label\n  &.focus-visible + span > span {\n    box-shadow: 0 0 0pt 2pt rgba(11, 153, 230, 0.4) !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { Label, Checkbox } from 'shared/components/legacy-rebass';
import { width } from 'styled-system';
import { Tooltip } from 'shared/components';
var CheckboxLabel = styled(Label)(_templateObject(), function(props) {
    return props.mt || 0;
}, function(props) {
    return props.mb || 0;
}, function(props) {
    return props.hidden ? 'none' : '';
}, width);
export var StyledCheckbox = styled(Checkbox)(_templateObject1(), function(param) {
    var hidden = param.hidden;
    return hidden ? 'none' : '';
}, function(param) {
    var disabled = param.disabled;
    return disabled && 'not-allowed' || 'pointer';
}, function(param) {
    var disabled = param.disabled, color = param.color;
    return disabled && '#b3b3b3 !important' || color || '#575e64';
}, function(param) {
    var disabled = param.disabled;
    return disabled ? 0.5 : 1;
}, function(param) {
    var disabled = param.disabled;
    return disabled ? 0.5 : 1;
});
var CheckBox = function(_param) {
    var name = _param.name, label = _param.label, _param_onChange = _param.onChange, onChange = _param_onChange === void 0 ? _.noop : _param_onChange, _param_onClick = _param.onClick, onClick = _param_onClick === void 0 ? _.noop : _param_onClick, _param_labelButton = _param.labelButton, labelButton = _param_labelButton === void 0 ? false : _param_labelButton, _param_labelButtonOnClick = _param.labelButtonOnClick, labelButtonOnClick = _param_labelButtonOnClick === void 0 ? false : _param_labelButtonOnClick, _param_tooltip = _param.tooltip, tooltip = _param_tooltip === void 0 ? false : _param_tooltip, inputId = _param.inputId, tooltipCopy = _param.tooltipCopy, className = _param.className, register = _param.register, hidden = _param.hidden, props = _object_without_properties(_param, [
        "name",
        "label",
        "onChange",
        "onClick",
        "labelButton",
        "labelButtonOnClick",
        "tooltip",
        "inputId",
        "tooltipCopy",
        "className",
        "register",
        "hidden"
    ]);
    return /*#__PURE__*/ _jsxs(CheckboxLabel, _object_spread_props(_object_spread({}, props), {
        className: "".concat(className, " checkbox-old"),
        hidden: hidden,
        children: [
            /*#__PURE__*/ _jsx(StyledCheckbox, _object_spread({
                inputId: inputId,
                "data-testid": inputId,
                name: name,
                onChange: onChange,
                onClick: onClick,
                register: register,
                hidden: hidden
            }, props)),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx("span", {}),
                    label,
                    labelButton && /*#__PURE__*/ _jsx("a", {
                        onClick: labelButtonOnClick,
                        children: labelButton
                    }) // eslint-disable-line
                ]
            }),
            tooltip && /*#__PURE__*/ _jsx(Tooltip, {
                tooltipCopy: tooltipCopy,
                grey: true,
                left: "auto",
                bottom: "30px",
                right: "-61px",
                width: "239px"
            })
        ]
    }));
};
export default CheckBox;
